import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ResetPassword from './pages/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import './styles/globals.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Ruta pública - Página de consulta de vehículos */}
        <Route path="/" element={<HomePage />} />

        {/* Rutas de autenticación */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/reset-password" element={<ResetPassword />} />

        {/* Rutas protegidas - Solo para administradores autenticados */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* Redirigir /admin a /admin/login */}
        <Route path="/admin" element={<Navigate to="/admin/login" replace />} />

        {/* Ruta por defecto - Redirigir a home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
